import { useEffect, useState } from 'react'

import { useWallet } from '@tronweb3/tronwallet-adapter-react-hooks'

import { TronAddress } from '@src/types/token'

export const useTronWallet = () => {
    const [isTronConnected, setIsTronConnected] = useState<boolean>(false)
    const [tronWalletAddress, setTronWalletAddress] = useState<TronAddress | undefined>(undefined)

    const { connected: tronWalletConnected, address: tronAddress } = useWallet()

    useEffect(() => {
        if (tronWalletConnected && tronAddress) {
            setIsTronConnected(true)
            setTronWalletAddress(tronAddress as TronAddress)
        } else {
            setIsTronConnected(false)
            setTronWalletAddress(undefined)
        }
    }, [tronWalletConnected, tronAddress])

    return {
        isTronConnected,
        tronWalletAddress,
    }
}
